module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-header'), _vm._v(" "), _c('el-side-nav'), _vm._v(" "), _c('el-app-main'), _vm._v(" "), _c('el-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5c0482a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/Layout.vue
// module id = 935
// module chunks = 0